import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Title from '../../heading/Title';
import styles from './phase-two.module.scss';

const PhaseText = (props) => {
  const data = useStaticQuery(graphql`
    {
      file: contentfulTwilloPhase2 {
        tagline
        title
        paragraph {
          content {
            content {
              value
            }
          }
        }
      }
    }
  `);

  const { tagline, title, paragraph } = data.file;
  const paragraphContent = paragraph.content[0].content[0].value;

  return (
    <div className={styles.phaseTextWrapper}>
      <h4 className={styles.phaseTextTwo}>{tagline}</h4>
      <Title>{title}</Title>
      <p className={styles.paragraph}>{paragraphContent}</p>
    </div>
  );
};

export default PhaseText;
